@if (hasCredentials()) {
    <div class="credentials">
        <p>*******</p>
        <app-link [disabled]="disabled()" (onClick)="showCredentials()">Show credentials</app-link>
    </div>
}
@else {
    @if (requested())
    {
        Credentials have been requested
    }
    @else {
        <app-link [disabled]="disabled()" (onClick)="requestCredentials()">Request credentials</app-link>
    }
}